<script setup lang="ts">
interface Props {
  message: string
}

defineProps<Props>()
</script>
<template>
  <CardComponent
    v-if="message"
    bg="light"
  >
    <div class="flex flex-nowrap gap-2">
      <div>
        <div class="h-full w-1 bg-primary rounded-full" />
      </div>
      <div class="text-xs flex-shrink">{{ message }}</div>
    </div>
  </CardComponent>
</template>
